module.exports = __webpack_public_path__ + "static/img/no-material.539d394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/no-material.png
// module id = Wavy
// module chunks = 96